export default "__VITE_ASSET__eN28rBuH__"